import React from 'react'
import Services from '../services'
import AboutSystem from '../about_system/about_system'
import styles from './home_box.module.css'

export default function HomeBox() {
    return (
        <div className={`${styles.container}`}>
            <div className={styles.shadow} />
            <Services />
            <div className={styles.about_container}><AboutSystem /></div>
        </div>
    )
}
